import { DialogFooter } from "@components/ui/dialog.tsx";
import { PrimaryButton, SecondaryButton } from "@sprout/buttons";
import useTranslation from "@hooks/use_translation.ts";
import { useSafePostHog } from "@/hooks/use_posthog";

type Props = {
  section: string;
  onSave: () => void;
  onCancel: () => void;
  saving?: boolean;
};

const ModalFooter = ({ section, onSave, onCancel, saving }: Props) => {
  const { t } = useTranslation("user", { keyPrefix: "profile_checklist.modals" });
  const posthog = useSafePostHog();

  const handleSave = () => {
    posthog?.capture("profile_widget_button_clicked", { button: "save", section });
    onSave();
  };

  return (
    <DialogFooter className="flex-row justify-end items-center">
      <SecondaryButton size="medium" onClick={onCancel}>
        {t("cancel")}
      </SecondaryButton>
      <PrimaryButton size="medium" loading={saving} onClick={handleSave}>
        {t("save")}
      </PrimaryButton>
    </DialogFooter>
  );
};

export default ModalFooter;
